import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HeaderPictureQuery } from '../../../../shared/state/header-picture/header-picture.query';
import { AppRolesModel } from '../../../../shared/models';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';

@Component({
    selector: 'app-header-personalized',
    templateUrl: './header-personalized.component.html',
    styleUrls: ['./header-personalized.component.scss'],
})
export class HeaderPersonalizedComponent implements OnInit {
    @Input() isLoadingContent;
    @Input() backgroundHeader;
    @Input() isBrowser: boolean;

    @Output() changeClinicSearchbarEvent: EventEmitter<any> = new EventEmitter<
        any
    >();

    logoHeader: string = null;
    rolePersonalizedBrowser = AppRolesModel.PersonalizedBrowser;
    appRole: number;
    constructor(
        private headerPicturesQuery: HeaderPictureQuery,
        private settingsQuery: SettingsQuery
    ) {}

    ngOnInit(): void {
        this.appRole = this.settingsQuery.appRole;

        this.headerPicturesQuery
            .select('homeCompany')
            .subscribe((homeCompany) => {
                this.logoHeader = homeCompany;
            });
    }

    onChangeClinicSearchbar(searchText: any) {
        this.changeClinicSearchbarEvent.emit(searchText);
    }
}
